// extracted by mini-css-extract-plugin
module.exports = {"checkboxMargin":"style_checkboxMargin__3hg0p","title":"style_title__S3YN7","checkboxNote":"style_checkboxNote__2w019","message":"style_message__emr-e"};